import { gql } from '@/utilities/gql';

import { NARRATIVE_OWNER_FRAGMENT } from '@/components/NarrativeAuthor';

export const NARRATIVE_FRAGMENT = gql(
  `
  fragment NarrativeFields on Narrative @_unmask {
    excerpt
    isDiscoverable
    companyId
    primaryCount
    contentBlocks {
      contentHtml
      id
      title
    }
    id
    slug
    title
    isPrimary
    valuation {
      exchangeRate
      discountRate
      fairValue
      futurePePercentageChange
      futureSharesOutstanding
      profitMarginPercentageChange
      revenuePercentageChange
      timeframe
      sharesOutstandingGrowthRate
      fiscalData {
        mostRecentReportedDate
        yearlyTimeSeries {
          year
          data {
            netIncome
            revenue
            endDate
            totalSharesOutstanding
          }
        }
      }
    }
    valuations {
      fairValue
      createdAt
    }
    voteCount {
      upvotes
    }
    announcements {
      contentHtml
      createdAt
      id
    }
    userHoldsPosition
    coverImageUrl
    createdAt
    updatedAt
    type
    owner {
      ...NarrativeOwnerFields
    }
    company {
      uniqueSymbolSlug
      country {
        iso2
      }
      primaryIndustry {
        slug
      }
    }
  }
`,
  [NARRATIVE_OWNER_FRAGMENT]
);
